import { render, staticRenderFns } from "./StarredKnowitCard.vue?vue&type=template&id=83ea641a&scoped=true"
import script from "./StarredKnowitCard.vue?vue&type=script&lang=js"
export * from "./StarredKnowitCard.vue?vue&type=script&lang=js"
import style0 from "./StarredKnowitCard.vue?vue&type=style&index=0&id=83ea641a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83ea641a",
  null
  
)

export default component.exports